import { memo, useCallback } from 'react';

import { StyleSheet, Text, View, Pressable } from 'react-native';
import { I18n, PlusButton, Navigation, DivWebOnly, Container } from '../../components';

import { __WEB__, COLOR, FONT, THEME } from '../../../constants/styles';
import { EVENT_TYPE_READINESS } from '../../../constants/eventTypes';

import { appointmentLabelForType, iconForType } from '../scheduler/common_views';

import {
  getAdminSchedulerEventTypes,
  getBaseSetupSchedulerEventTypesPermissions,
} from '../../../selectors/scheduler';
import { useSelector } from 'react-redux';

function open(type, canEdit) {
  Navigation.showModal({
    screen: 'ApptHoursForm',
    title: I18n.t('airforce.scheduleSetup', { type: appointmentLabelForType(type) }),
    passProps: {
      eventType: type,
      desc: I18n.t('airforce.numProviderFormDesc', { type }),
      canEdit,
    },
    options: {
      width: 550,
    },
  });
}

const MenuItem = memo(function MenuItem(props) {
  const handlePress = useCallback(() => {
    props.onPress(props.eventType);
  }, [props.onPress, props.eventType]);
  return (
    <Pressable style={styles.item} onPress={handlePress}>
      <DivWebOnly className="outlined">
        <PlusButton
          source={props.source}
          onPress={handlePress}
          iconStyle={[styles.iconStyle, props.iconStyle]}
          buttonStyle={styles.buttonStyle}
        />
      </DivWebOnly>
      <Text style={styles.labelStyle}>{props.label}</Text>
    </Pressable>
  );
});

export default memo(function Menu(props) {
  const availableEventTypes = useSelector(getAdminSchedulerEventTypes);
  const setupPerms = useSelector(getBaseSetupSchedulerEventTypesPermissions);
  const eventTypesList = availableEventTypes.filter((et) => et !== EVENT_TYPE_READINESS);
  if (!eventTypesList.length) return null;

  const openItem = useCallback(
    (type) => {
      open(type, setupPerms[type]?.canEdit);
    },
    [setupPerms]
  );

  function renderItem(type) {
    if (!setupPerms[type]?.canView) return null;
    const label = appointmentLabelForType(type);
    return (
      <MenuItem
        key={type}
        onPress={openItem}
        source={iconForType(type)}
        label={label}
        eventType={type}
      />
    );
  }

  return (
    <Container scrollView={true} contentContainerStyle={styles.container}>
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1 }}>
          {eventTypesList.map((eventType, i) => i % 2 === 0 && renderItem(eventType))}
        </View>
        <View style={{ flex: 1, paddingLeft: 30 }}>
          {eventTypesList.map((eventType, i) => i % 2 !== 0 && renderItem(eventType))}
        </View>
      </View>
    </Container>
  );
});

const styles = StyleSheet.create({
  container: {
    padding: 25,
  },
  item: {
    ...THEME.basicRow,
    marginBottom: 15,
  },
  btnText: {
    ...FONT.semibold,
    fontSize: 11,
    color: COLOR.emphasis,
  },
  labelStyle: {
    ...THEME.rowText,
    ...THEME.linkStyle,
    marginLeft: 20,
  },
  iconStyle: {
    width: 27,
    height: 27,
    tintColor: 'rgb(44, 66, 107)',
  },
  buttonStyle: {
    width: 50,
    height: 50,
  },
});
